import loadable from 'react-loadable';

const LoadableComposeModalRoot = loadable({
    loader: () => import(/* webpackChunkName: "compose-modal-root" */ './ComposeModalRoot'),
    loading: () => null,
});

export default LoadableComposeModalRoot;
